
function colorFiltering (products, colors, variantKey) {
  return products.filter(p => colors.includes(p[variantKey][0].BaseColor));
}
export const GetVariantKey = function (outlet, archived) {
  return archived ? 'ArchivedVariants' : outlet ? 'OutletVariants' : 'ActiveVariants';
};
export const SplitAllColors = function (products, filterColors = [], outlet = false, archived = false) {
  let list = [];
  const variantKey = GetVariantKey(outlet, archived);

  // split variants into products
  products.forEach(product => {
    const variants = product[variantKey];
    variants.forEach(variant => {
      const splitProduct = { ...product };
      splitProduct.isSplitted = true;
      splitProduct.MainColor = variant.ColorCode;
      splitProduct[variantKey] = [variant];
      list.push(splitProduct);
    });
  });

  // filter colors from splitted variants
  if (filterColors.length) {
    list = colorFiltering(list, filterColors, variantKey);
  }
  return list;
};
export const RemoveEmptyProducts = function (list, outlet, archived) {
  const variantKey = GetVariantKey(outlet, archived);
  return list.filter(item => item[variantKey] && item[variantKey].length > 0);
};

export const FilterBySize = function (list, sizeFilter = [], outlet, archived) {
  const variantKey = GetVariantKey(outlet, archived);
  return list.filter(item => {
    let match = false;

    item[variantKey][0].SizeVariations.forEach(sizeVariant => {
      if (sizeFilter.includes(sizeVariant.Size) && sizeVariant.Inventory > 0) {
        match = true;
      }
    });
    return match;
  });
};
